<!-- 礼品规格管理 GiftSpec-->
<template>
  <div class="GiftSpec">
    <div class="form_header">
      <!-- <el-form ref="form" :model="userform" label-width="100px">
        <div class="form_list">
          <el-form-item label="礼品名称：">
            <el-input v-model="userform.name"></el-input>
          </el-form-item>
          <div class="btn_box">
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button>取消</el-button>
          </div>
        </div>
      </el-form>-->

      <el-button type="primary" icon="el-icon-tickets" @click="mode">下载模板</el-button>
      <el-upload class="upload-demo" action accept=".xlsx, .xls, .csv" :show-file-list="false" :http-request="handlePreview" :limit="1">
        <el-button type="primary" icon="el-icon-download">导入</el-button>
      </el-upload>
      <!-- <el-button type="primary" icon="el-icon-upload2">导出</el-button> -->
      <el-button type="primary" icon="el-icon-plus" @click="addPoints">新增</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="addLink">文字和超链接</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="addSymbol">币种符号</el-button>
    </div>
    <div class="user_list">
      <el-table :data="giftList" style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="name" label="礼品名称"></el-table-column>
        <el-table-column prop="price" label="礼品金额"></el-table-column>
        <el-table-column prop="img" label="礼品图片">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 40px" :src="domainUrl+scope.row.img" :preview-src-list="scope.row.srcList"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="integral" label="所需积分"></el-table-column>
        <el-table-column prop="gift_hidden_count" label="已兑换"></el-table-column>
        <el-table-column prop="not_issued_count" label="未发放"></el-table-column>
        <el-table-column prop="gift_normal_count" label="剩余"></el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editbox(scope.row)">编辑</el-button>
            <el-button @click="removesize(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
    <!-- 新增--编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="pop_up" @close="cancelform">
      <el-form :model="Edform" :rules="rules" label-width="100px">
        <el-form-item label="礼品名称">
          <el-input v-model="Edform.name" placeholder="请输入礼品名称"></el-input>
        </el-form-item>
        <el-form-item label="礼品金额">
          <el-input v-model="Edform.price" placeholder="请输入礼品金额"></el-input>
        </el-form-item>
        <el-form-item label="礼品图片">
          <el-upload action list-type="picture-card" :http-request="handaddimg" accept=".png, .jpg, .jpeg" :limit="1" :file-list="Edform.fileList" :class="{ hideUpload: Edform.fileList.length > 0 }" :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="所需积分">
          <el-input v-model="Edform.integral" placeholder="请输入所需积分"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelform">取 消</el-button>
        <el-button type="primary" @click="SubmitAdd">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="文字和超链接" :visible.sync="linkDialog">
      <quill-editor v-model="currencyList.content" :options="editorOption" style="margin-bottom:20px"/>
      <el-button @click="cancelDa">取 消</el-button>
      <el-button type="primary" @click="SubmitEdit">确 定</el-button>
    </el-dialog>

    <el-dialog title="币种符号" :visible.sync="SymbolDialog">
      <el-input v-model="currencyList.icon" placeholder="请输入符号"></el-input>
      <el-button @click="cancelDa">取 消</el-button>
      <el-button type="primary" @click="SubmitEdit">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  categoryGiftlists,
  categoryGiftadd,
  categoryGiftdelete,
  categoryGiftedit
} from "../../api/system.js";
import {
  uploadimg,
  hostimg,
  categoryGifttemplate,
  excelimport,
  getCurrencys,
  currencyEdit
} from "../../api/comm.js";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    quillEditor
  },
  data() {
    //这里存放数据
    return {
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
            ["blockquote", "code-block"], //引用，代码块
            [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
            [{ list: "ordered" }, { list: "bullet" }], //列表
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            [{ color: [] }], // 字体颜色，字体背景颜色
            ["link"] //上传图片、上传视频
          ]
        },

        theme: "snow"
      },
      userform: {
        Product: "",
        name: ""
      },
      Edform: {
        name: "",
        integral: "",
        price:'',
        fileList: []
      },
      giftList: [
        {
          name: "9f30002",
          num: "1000",
          name1: "启用"
        }
      ],
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      titleName: "新增",
      pop_up: false,
      linkDialog:false,
      SymbolDialog:false,
      currencyList:{},
      rules: {
        reason: [{ required: true, message: "请输入拒绝原因", trigger: "blur" }]
      },
      domainUrl: ""
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    addLink(){
      this.linkDialog = true
      this.getCurrency()
    },
    addSymbol(){
      this.SymbolDialog = true
      this.getCurrency()
    },
    SubmitEdit(){
      let data = {
        id:this.currencyList.id,
        icon:this.currencyList.icon,
        content:this.currencyList.content
      }
      currencyEdit(data).then(res=>{
        if(res.status_code == 200){
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          this.cancelDa()
        }
      })
    },
    cancelDa(){
      this.linkDialog = false
      this.SymbolDialog = false
    },
    getCurrency(){
      getCurrencys().then(res=>{
        if(res.status_code == 200){
          res.data.map(item=>{
            if(item.id == parseInt(localStorage.getItem('countryId'))){
              this.currencyList = item
            }
          })
          console.log(this.currencyList)
        }
      })
    },
    rowStyle() {
      return { textAlign: "center" };
    },
    //实时域名
    domainName() {
      hostimg().then(res => {
        // console.log(res);
        if (res.code == 200) {
          this.domainUrl = res.data.url;
          this.giftdata();
        }
      });
    },
    //礼品分类列表
    giftdata() {
      let data = {
        page: this.currentindex,
        page_size: this.pageSize,
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      categoryGiftlists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          res.data.data.forEach((ele, i) => {
            res.data.data[i].srcList = [];
            res.data.data[i].srcList.push(this.domainUrl + ele.img);
          });
          this.giftList = res.data.data;
          this.totals = res.data.total;
        }
      });
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
      this.giftdata();
    },
    //搜索
    onSubmit() {
      // console.log(this.userform);
    },
    // 新增--弹窗
    addPoints() {
      this.titleName = "新增";
      this.pop_up = true;
    },
    //编辑弹窗
    editbox(e) {
      this.titleName = "编辑";
      this.pop_up = true;
      // console.log(e);
      this.Edform.integral = e.integral;
      this.Edform.name = e.name;
      this.Edform.price = e.price;
      this.Edform.id = e.id;
      this.Edform.fileList.push({
        path: e.img,
        url: this.domainUrl + e.img
      });
    },
    //图片上传
    handaddimg(file) {
      // console.log(file);
      let minfile = file.file;
      let form = new FormData();
      form.append("file", minfile);
      uploadimg(form).then(res => {
        // console.log(res);
        // console.log(this.Edform.fileList);
        if (res.status_code == 200) {
          this.Edform.fileList.push({
            name: res.data.original_name,
            url: res.data.url,
            path: res.data.path
          });
        }
      });
    },
    //弹窗提交
    SubmitAdd() {
      // console.log(this.Edform);
      if (this.titleName == "新增") {
        if (this.Edform.name == "" || this.Edform.integral == "") {
          this.$message({
            type: "warning",
            message: "请将信息填写完整!"
          });
        } else if (this.Edform.fileList.length == 0) {
          this.$message({
            type: "warning",
            message: "请上传礼品图片!"
          });
        } else {
          let data = {
            name: this.Edform.name,
            price: this.Edform.price,
            img: this.Edform.fileList[0].path,
            integral: this.Edform.integral,
            currency_id:parseInt(localStorage.getItem('countryId'))
          };
          categoryGiftadd(data).then(res => {
            if (res.status_code == 200) {
              this.pop_up = false;
              this.currentindex = 1;
              this.giftdata();
              this.$message({
                type: "success",
                message: "新增成功!"
              });
            }
          });
        }
      } else {
        if (this.Edform.name == "" || this.Edform.integral == "") {
          this.$message({
            type: "warning",
            message: "请将信息填写完整!"
          });
        } else if (this.Edform.fileList.length == 0) {
          this.$message({
            type: "warning",
            message: "请上传礼品图片!"
          });
        } else {
          let data = {
            id: this.Edform.id,
            name: this.Edform.name,
            price: this.Edform.price,
            img: this.Edform.fileList[0].path,
            integral: this.Edform.integral,
            currency_id:parseInt(localStorage.getItem('countryId'))
          };
          categoryGiftedit(data).then(res => {
            if (res.status_code == 200) {
              this.pop_up = false;
              this.currentindex = 1;
              this.giftdata();
              this.$message({
                type: "success",
                message: "编辑成功!"
              });
            }
          });
        }
      }
    },
    //弹窗取消
    cancelform() {
      this.pop_up = false;
      this.Edform.integral = "";
      this.Edform.name = "";
      this.Edform.fileList = [];
    },

    //删除上传
    handleRemove(file) {
      // console.log(file);
      this.Edform.fileList = [];
    },
    //选中
    handleSelectionChange(val) {
      // console.log(val);
    },
    //删除
    removesize(e) {
      // console.log(e);
      let data = {
        id: e.id
      };
      this.$confirm(
        "删除该礼品，该礼品下的秘钥将不会再发放。确定删除?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          categoryGiftdelete(data).then(res => {
            if (res.status_code == 200) {
              this.currentindex = 1;
              this.giftdata();
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            }
          });
        })
        .catch(() => {});
    },
    //模板下载
    mode() {
      location.href= process.env.VUE_APP_BASE_API + '/template_file/lipinfenlei_template.xls'
      // categoryGifttemplate().then(res => {
      //   // console.log(res);
      //   const blob = new Blob([res]);
      //   const downloadElement = document.createElement("a");
      //   const href = window.URL.createObjectURL(blob); // 创建下载的链接
      //   downloadElement.href = href;
      //   downloadElement.download = "礼品模板.xlsx"; // 下载后文件名
      //   document.body.appendChild(downloadElement);
      //   downloadElement.click(); // 点击下载
      //   document.body.removeChild(downloadElement); // 下载完成移除元素
      //   window.URL.revokeObjectURL(href); // 释放掉blob对象
      // });
    },
    //导入--上传
    handlePreview(file) {
      // console.log(file);
      let minfile = file.file;
      let form = new FormData();
      form.append("file", minfile);
      form.append("type", "category_gift");
      form.append("currency_id",localStorage.getItem('countryId'))
      let data = {
        file: minfile,
        type: "category_gift"
      };
      excelimport(form).then(res => {
        if (res.status_code == 200) {
          this.currentindex = 1;
          this.giftdata();
          this.$message({
            type: "success",
            message: "导入成功!"
          });
        }
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.domainName();
    
    // this.giftdata();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.GiftSpec {
  padding: 20px 30px 0;
  .form_header {
    display: flex;
    // justify-content: space-between;
    .btn_box {
      margin-left: 20px;
    }
    .upload-demo {
      margin: 0 10px;
    }
  }
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    padding: 20px 0;
  }
}
</style>
<style lang='scss'>
.GiftSpec {
  .form_header {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
}
.hideUpload {
  .el-upload.el-upload--picture-card {
    display: none !important;
  }
}
.ql-container {
  height: 300px;
}
</style>